export default "__VITE_ASSET__23c941cf__"